module.exports = __webpack_public_path__ + "img/09.1086506a.png";